import React from 'react';
import {
  Drawer,Card,
  Table,
  Button,List,
  Space,
  Typography,
  Tag,
  Empty,
  Tooltip,Divider,Select
} from 'antd';

import {
  ExclamationCircleOutlined, FilterOutlined,  
  DeleteOutlined,LoadingOutlined ,
  SearchOutlined,
  CalendarOutlined,
  UserOutlined,
  HomeOutlined,  
} from '@ant-design/icons';

import moment from 'moment';

import dayjs from 'dayjs';

const { Text } = Typography;

const AsignacionHabitacionesDrawer = ({
  drawerAsignacionVisible,
  onClose,
  lineaSeleccionadaAsignacion,
  habitacionesDisponibles,
  habitacionAsignada,
  cargandoAsignacion,
  asignarHabitacion,  cerrarDrawerAsignacion,
  plantasDisponibles,tiposHabitacionDisponibles,cargandoHabitacionesDisponibles,desasignarHabitacion
}) => {
  return (
    <Drawer
        title={
                lineaSeleccionadaAsignacion ? (
                    <Card size="small" style={{ marginBottom: 16, borderColor: '#1890ff' }}>
                        <Space direction="vertical" style={{ width: '100%' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>
                                    <Text strong>Habitación {lineaSeleccionadaAsignacion.Linea}</Text>
                                    <Tag color="blue" style={{ marginLeft: 8 }}>
                                        {lineaSeleccionadaAsignacion.TipoHab}
                                    </Tag>
                                </div>
                                <div>
                                    <Text type="secondary">Ocupante {lineaSeleccionadaAsignacion.Numocupante}</Text>
                                </div>
                            </div>                      
                            <div>
                                <Text strong>Cliente:</Text> {lineaSeleccionadaAsignacion.Nombre}
                            </div>                      
                            
                            <div>
                                <CalendarOutlined style={{ marginRight: 4 }} />
                                <Text strong>Fechas:</Text> {moment(lineaSeleccionadaAsignacion.Entrada).format('DD/MM/YY')} - {moment(lineaSeleccionadaAsignacion.Salida).format('DD/MM/YY')}
                                <Text type="secondary" style={{ marginLeft: 8 }}>
                                    ({moment(lineaSeleccionadaAsignacion.Salida).diff(moment(lineaSeleccionadaAsignacion.Entrada), 'days')} noches)
                                </Text>
                            </div>
                      
                            {lineaSeleccionadaAsignacion.NumHab ? (
                                <div style={{ 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                justifyContent: 'space-between',
                                                padding: 8,
                                                backgroundColor: '#f6ffed',
                                                borderRadius: 4,
                                                border: '1px solid #b7eb8f'
                                            }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <HomeOutlined style={{ color: '#52c41a', marginRight: 8 }} />
                                        <div>
                                            <Text strong style={{ color: '#52c41a' }}>Habitación asignada:</Text>
                                            <div style={{ fontSize: 18, fontWeight: 'bold', color: '#52c41a' }}>
                                                {lineaSeleccionadaAsignacion.NumHab}
                                            </div>
                                        </div>
                                    </div>
                                    <Button 
                                        danger 
                                        size="small" 
                                        icon={<DeleteOutlined />}
                                        onClick={() => desasignarHabitacion()}
                                        loading={cargandoAsignacion}
                                    >
                                        Quitar
                                    </Button>
                                </div>
                            ) : (
                                <div style={{ 
                                                padding: 8, 
                                                backgroundColor: '#fff7e6', 
                                                borderRadius: 4,
                                                border: '1px solid #ffd591'
                                            }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <ExclamationCircleOutlined style={{ color: '#faad14', marginRight: 8 }} />
                                        <div>
                                            <Text strong style={{ color: '#faad14' }}>Sin habitación asignada</Text>
                                            <div style={{ fontSize: 11, color: '#faad14' }}>
                                                Seleccione una habitación de la lista
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Space>
                    </Card>
                ) : ('') 
            }
            placement="right"
            width={450}
            open={drawerAsignacionVisible}
            onClose={() => cerrarDrawerAsignacion()}
        >
        
            {lineaSeleccionadaAsignacion ? (
                <div>                                    
                    {/* Filtros y controles */}
                    <Divider orientation="left">
                        <FilterOutlined /> Controles Rápidos
                    </Divider>
                  
                    <Space direction="vertical" style={{ width: '100%' }}>
                    
                    
                        <div style={{ display: 'flex', gap: 8 }}>
                            <Select
                                style={{ flex: 1 }}
                                placeholder="Filtrar por planta"
                                onChange={(planta) => filtrarPorPlanta(planta)}
                                allowClear
                            >
                                {plantasDisponibles.map(planta => (
                                    <Select.Option key={planta} value={planta}>
                                        Planta {planta}
                                    </Select.Option>
                                ))}
                            </Select>
                      
                            <Select
                                style={{ flex: 1 }}
                                placeholder="Filtrar por tipo"
                                onChange={(tipo) => filtrarPorTipo(tipo)}
                                allowClear
                            >
                                {tiposHabitacionDisponibles.map(tipo => (
                                    <Select.Option key={tipo} value={tipo}>
                                        {tipo}
                                    </Select.Option>
                                ))}
                            </Select>
                        </div>
                    </Space>                  
                  
                    {/* Habitaciones disponibles */}
                    <Divider orientation="left">
                        <SearchOutlined /> Habitaciones Disponibles.
                        <Tag color="blue" style={{ marginLeft: 8 }}>
                            {habitacionesDisponibles.length} disponibles
                        </Tag>
                        {cargandoHabitacionesDisponibles && (
                            <LoadingOutlined style={{ marginLeft: 8 }} />
                        )}
                    </Divider>
                  
                    {habitacionesDisponibles.length > 0 ? (
                        <List
                            dataSource={habitacionesDisponibles}
                            loading={cargandoHabitacionesDisponibles}
                            renderItem={(habitacion) => (
                                <List.Item style={{ padding: '4px 0', border: 'none' }}>
                                <Card
                                    size="small"
                                    hoverable
                                    onClick={() => {
                                    asignarHabitacion(habitacion.NumHab);
                                    // setTimeout(() => buscarSiguienteLineaSinHabitacion(), 500);
                                    }}
                                    style={{
                                    width: '100%',
                                    cursor: 'pointer',
                                    border: `2px solid ${habitacion.Estado === 0 ? '#d9f7be' : '#ffccc7'}`,
                                    backgroundColor: habitacion.Estado === 0 ? '#f6ffed' : '#fff2f0',
                                    transition: 'all 0.2s'
                                    }}
                                    bodyStyle={{ padding: '6px 10px' }}
                                    onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
                                    }}
                                    onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = 'none';
                                    }}
                                >
                                    <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px'
                                    }}>
                                    {/* Número de habitación - grande a la izquierda */}
                                    <div style={{
                                        fontSize: '24px',
                                        fontWeight: 'bold',
                                        color: habitacion.Estado === 0 ? '#389e0d' : '#cf1322',
                                        minWidth: '70px',
                                        textAlign: 'center',
                                        lineHeight: 1
                                    }}>
                                        {habitacion.NumHab}
                                    </div>

                                    {/* Info en dos filas */}
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '2px',
                                        flex: 1,
                                        fontSize: '11px',
                                        color: '#666',
                                        lineHeight: 1.2
                                    }}>
                                        {/* Fila 1: Tipo, Planta y Descripción */}
                                        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>                                        
                                        <span><span style={{ color: '#999' }}>Planta:</span> {habitacion.Piso || 'N/A'}</span>
                                        <span><span style={{ color: '#999' }}>Tipo:</span> {habitacion.nombreHabitacionVenta || 'Standard'}</span>
                                        </div>

                                        {/* Fila 2: Última ocupación y capacidad */}
                                        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                                        <span><span style={{ color: '#999' }}>Últ. ocup.:</span> {habitacion.ocupadasAnterior || 'N/A'}</span>
                                        <span><span style={{ color: '#999' }}>Próx. entr.:</span> {habitacion.SiguienteEntrada && dayjs(habitacion.SiguienteEntrada).isValid()
                                                                                                                                        ? dayjs(habitacion.SiguienteEntrada).format('DD-MM-YYYY')
                                                                                                                                        : 'N/A'}</span>
                                        </div>
                                    </div>
                                    </div>
                                </Card>
                                </List.Item>
                            )}
                            />
                    ) : (
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={
                                <div>
                                    <div>No hay habitaciones disponibles</div>
                                    <Text type="secondary" style={{ fontSize: 12 }}>
                                        Para las fechas seleccionadas
                                    </Text>
                                </div>
                            }
                        />
                    )}
                </div>
            ) : (
                <div style={{ textAlign: 'center', padding: 40 }}>
                    <UserOutlined style={{ fontSize: 48, color: '#d9d9d9', marginBottom: 16 }} />
                    <div>Seleccione una línea de la tabla</div>
                    <Text type="secondary" style={{ marginBottom: 24 }}>
                        Para comenzar a asignar habitaciones
                    </Text>
                    <Button 
                        type="primary" 
                        onClick={() => {
                            // Ir directamente a la primera línea sin asignar
                            irAPrimeraLineaSinHabitacion();
                        }}
                    >
                        <SearchOutlined /> Buscar primera línea sin asignar
                    </Button>
                </div>
            )}
        </Drawer>
    );
};

export default AsignacionHabitacionesDrawer;
